import { Component, OnInit  } from '@angular/core';

@Component({
  selector: 'app-translation',
  templateUrl: './translation.component.html',
  styleUrls: ['./translation.component.css']
})

export class TranslationComponent implements OnInit {
  selectedTabIndex: number = 0;
  //navLinks = [
  //  { path: 'listtrans', label: 'Translations' },
  //  { path: 'edittrans', label: 'Edit Translation' },
  //  { path: 'createtrans', label: 'Create Translation' }  
  //];
  //activeLink = this.navLinks[0].path;
  constructor() {
   
  }

  selectedTab(index: number): void {
    this.selectedTabIndex = index;
  }
  ngOnInit() {
  }
  
}

